import { useEffect, useRef, useState } from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import styled from "styled-components";
import avatarProfile from "../Assets/Images/avatar.jpg";
import client from "../client/api";
import { Search } from "../Components/Search";
import { Typography } from "../Components/Typography";
import CONSTANTS from "../constants";
import useQuery from "../routes/helper/useQueryHooks";
import leftArrow from "./../Assets/Images/arrow-left.png";
import rightArrow from "./../Assets/Images/arrow-right.png";


// $link-transition: color 250ms ease, background-color 250ms ease;

const CodivaCardContainer = styled.div`
display: grid;
  /* grid-template-columns: 1fr  ;
  grid-template-rows: 1fr; */
  column-gap: 2%;
  width: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
`
const Avatar = styled.img`
  border-radius: 50%;
  width: 100px;
`

const AvatarContainer = styled.section`
  display: flex;
flex-direction:column;

  justify-content: center;
  flex-flow: wrap column;
  align-items: center;
`

const AvatarItem = styled.article`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px;
  padding: 5px;

    text-align: center;

`

const AvatarIconStyled = styled.article`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4%;
  width: 25px;
  cursor: pointer;
`

const LinkedinIcon = styled(FaLinkedinIn)`
  color: #78529c;
`

const InstagramIcon = styled(FaInstagram)`
  color: #78529c;
`
const AvatarIconLinkedin = ({ url = "#" }) => (
  <AvatarIconStyled>
    <a href={`https://www.linkedin.com/${url}`} target={"_blank"} rel="noreferrer">
      <LinkedinIcon />
    </a>
  </AvatarIconStyled>
)

const AvatarIconInstagram = ({ url = "#" }) => (
  <AvatarIconStyled>
    <a href={`https://www.instagram.com/${url}/`} target={"_blank"} rel="noreferrer">
      <InstagramIcon />
    </a>
  </AvatarIconStyled>
)
const CodivaCard = styled.div`

  position: relative;
  grid-row: 5;

  min-height: 250px;
  min-width: 280px;
  border: 3px solid ${CONSTANTS.COLORS.colorMain};
  border-radius: 15px;
  padding: 13px 10px;
  color: white;

  @media screen and (max-width: 800px) {


    column-gap: 3%;

}
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 3rem;
    margin-bottom: 1rem;
  }
  p {
    font-style: normal;
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.2rem;
  }

  button {
    width: 6rem;
    height: 2rem;
    background: $color-hilight;
    border-radius: 2rem;
    position: absolute;
    bottom: 1rem;
    left: 1.5rem;
    outline: none;
    border: none;
    -webkit-transition: transform 200ms ease-in-out;
    -moz-transition: transform 200ms ease-in-out;
    -o-transition: transform 200ms ease-in-out;
    transition: transform 200ms ease-in-out;
    &:hover {
      transform: scale(1.05);
    }
  }

`
const Codivas = () => {
  const query = useQuery().get("q")

  let [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  //variables

  // TODO( replace this in future for call in api )
  if (query) profiles = profiles.filter(item => Object.values(item).some(i => RegExp(query, "ig").test(i)))

  const ref = useRef(null);

  const scrollLength = 100;

  // function to scroll via the left and right buttons
  useEffect(() => {
    if (loading)
      client
        .get(CONSTANTS.API.PROFILE)
        .then((response) => {
          mappedProfile(response.data);
        })
        .catch((e) => {
          setLoading(false);
          if (e.isAxiosError)
            setApiError(CONSTANTS.ERROR_MESSAGE.api(e.response.data.message));
          else setApiError(e.message);
        });
  }, [profiles]);

  const mappedProfile = (data) => {
    setProfiles(
      data.map((profile) => ({

        name: profile.preferenceName || "", lastName: profile.lastName || "",


        avatarUrl: profile.avatarUrl || avatarProfile,
        currentPosition: profile.currentPosition,
        skills: profile.skills.map((k) => k.toUpperCase()).join(" , "),
        address: `${profile.city || ""}, ${profile.uf || ""}`,
        linkedin: profile.linkedin,
        instagram: profile.instagram,
        skills: profile.skills
      }))
    );

    setLoading(false);
  };
  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };




  return (
    <div className="Project-content">
      <div className="project-header">
        <Typography fontSize={"4"}> {"< Codivas >"}</Typography>

      </div>
      <Search />

      <div className="project-info">
        <div className="button-container">
          <img
            src={leftArrow}
            alt="previous"
            onClick={() => scroll(-scrollLength)}
          />
        </div>




        <CodivaCardContainer ref={ref}>
          {loading ? (
            <>
              <div style={{ padding: "10% 5%", textAlign: "center" }}>
                <h1 style={{ fontSize: "2rem", color: "green" }}>Loading...</h1>
              </div>
            </>
          )
            : apiError ? (
              <>
                <div style={{ padding: "10% 5%", textAlign: "center" }}>
                  <h1 style={{ fontSize: "2rem", color: "green" }}>{apiError}</h1>
                </div>
              </>
            ) : profiles == 0 ? (
              <>
                <div className="row" style={{ padding: "10% 5%", textAlign: "center" }}>
                  <h1 style={{ fontSize: "2rem", color: "green" }}>
                    Estamos sem perfis compátiveis no momento
                  </h1>
                </div>
              </>
            ) : (
              profiles
                .map((item) => {
                  //name
                  const firstName = item.name.split(' ')[0];
                  const lastName = item.lastName.split(' ')[0];

                  const nameString = `${firstName} ${lastName}`;

                  //skill
                  const displayedSkills = item.skills.slice(0, 3);
                  const moreSkillsCount = item.skills.length - displayedSkills.length;
                  const skillsString = displayedSkills.join(", ");

                  return (
                    <CodivaCard key={item.name} id={item.name} >
                    <AvatarContainer>
                      <Avatar src={item.avatarUrl} />
                      <AvatarItem>
                        <Typography variant={"primary"} fontSize={"h2"}> {nameString}</Typography>
                      </AvatarItem>
                      <AvatarItem>
                        <Typography>{item.currentPosition || ""}</Typography>
                      </AvatarItem>
                      <AvatarItem>
                        <Typography>{skillsString}{moreSkillsCount > 0 ? `... (+${moreSkillsCount} mais)` : ''}</Typography>
                      </AvatarItem>
                      <AvatarItem>
                        <Typography>{item.address}</Typography>
                      </AvatarItem>
                      <AvatarItem>
                        <AvatarIconLinkedin url={item.linkedin} />
                        <AvatarIconInstagram url={item.instagram?.replace('@', '')} />
                      </AvatarItem>
                    </AvatarContainer>
                  </CodivaCard>
                  );
                })
            )}
        </CodivaCardContainer>









        <div className="button-container">
          <img
            src={rightArrow}
            alt="previous"
            onClick={() => scroll(scrollLength)}
          />
        </div>
      </div>
    </div>
  );
};

export default Codivas;
